import { inject } from '@angular/core';
import { ExecutableMenuItem } from '@softline/application';
import { translator } from '@softline/ui-core';
import { OffeneKopfkommsService } from '../services/offene-kopfkomms.service';
import { KommissionsauftragKopf } from '../types/kommissionsauftrag';

export function offeneKopfkommsMenuItemFn(): (
  order: KommissionsauftragKopf | null | undefined
) => ExecutableMenuItem {
  const t = translator();
  const service = inject(OffeneKopfkommsService);
  return (order) => ({
    name: 'offene-kopfkomms',
    title: t('#KOMMISSIONIERUNG.ACTIONS.OFFENE_AUFTRAEGE')(),
    type: 'execute',
    outlet: 'action',
    icon: 'fa-regular fa-list-check',
    tooltip: true,
    tooltipPosition: 'left',
    canExecute: true,
    visible: (order?.offeneKopfkomms?.length ?? 0) > 0,
    execute: () => service.selectAndTakeOver(order?.offeneKopfkomms ?? []),
  });
}
